export const deployAPI = 'https://reel-reviews-backend.herokuapp.com';
export const localAPI = 'http://localhost:8080';